import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { Operator } from '../../operator/models/Operator';
import { OperatorList } from '../../operator/models/OperatorList';
import { AnreService } from '../service/anre.service';

type Pagination = {
  pageNumber: number;
  className: string;
}

@Component({
  selector: 'app-operators-anre',
  templateUrl: './operators-anre.component.html',
  styleUrls: ['./operators-anre.component.scss']
})
export class OperatorsAnreComponent implements OnInit {

  public eeOperators: Operator[];
  public gnOperators: Operator[];
  public size = 10
  public pageElectr = 0
  public pageGas = 0
  public nameFilterGas = ""
  public codeFilterGas = ""
  public totalResultsGas = 0
  public nameFilterElectr = ""
  public codeFilterElectr = ""
  public totalResultsElectr = 0
  public paginationElementsGas: Pagination[]
  public paginationElementsElectr: Pagination[]
  public electricOperatorsDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'modifyIntegration',
          title: '<p>Modifica integrarea</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    columns: {
      name: {
        title: 'Operator loc consum'
      },
      code: {
        title: 'CUI'
      },
      electricityLicence: {
        title: 'Licenta Electricitate'
      },
      gasLicence: {
        title: 'Licenta gaz'
      },
      associationStatus: {
        title: 'Status'
      },
      integrated: {
        title: 'Status integrare',
        valuePrepareFunction: (integrated: any) => {
          return integrated ? 'Integrat' : 'Neintegrat';
        }
      }
    },
    pager: {
      display: false
    }
  };
  public gasOperatorsDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'modifyIntegration',
          title: '<p>Modifica integrarea</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    columns: {
      name: {
        title: 'Operator loc consum'
      },
      code: {
        title: 'CUI'
      },
      electricityLicence: {
        title: 'Licenta Electricitate'
      },
      gasLicence: {
        title: 'Licenta gaz'
      },
      associationStatus: {
        title: 'Status'
      },
      integrated: {
        title: 'Status integrare',
        valuePrepareFunction: (integrated: any) => {
          return integrated ? 'Integrat' : 'Neintegrat';
        }
      }
    },
    pager: {
      display: false
    }
  };

  @ViewChild(NgbTabset, { static: false }) tabset: { activeId: string; }

  constructor(
    private anreService: AnreService
  ) { }

  ngOnInit(): void {
    this.anreService.getAnreElectricOperators("", "", this.pageElectr, this.size).subscribe(value => this.eeOperatorsLoaded(value));
    this.anreService.getAnreGasOperators("", "", this.pageGas, this.size).subscribe(value => this.gnOperatorsLoaded(value));
  }

  onCustomActionElectricSuppliers(event: any): void {
    switch (event.action) {
      //     case 'activate/inactivate': {
      //       localStorage.setItem('supplier', JSON.stringify(event.data));
      //       this.router.navigateByUrl('/anre/furnizor-fui');
      //       break;
      //     }
      //     case 'suspend': {
      //       localStorage.setItem('supplier', JSON.stringify(event.data));
      //       localStorage.setItem('licence', JSON.stringify(event.data.electricityLicence));
      //       this.router.navigateByUrl('/anre/licenta-furnizor');
      //       break;
      //     }
      //     case 'view': {
      //       localStorage.setItem('supplierId', event.data.id);
      //       this.router.navigateByUrl('/anre/furnizor-detalii');
      //       break;
      //     }
      case 'modifyIntegration': {
        event.data.integrated = !event.data.integrated;
        this.anreService.modifyOperatorIntegration(event.data).subscribe(() => this.ngOnInit());
        break;
      }
    }
  }
  //
  
  onCustomActionGasSuppliers(event: any): void {
    console.log(event);
    switch (event.action) {
      //     case 'activate/inactivate': {
      //       localStorage.setItem('supplier', JSON.stringify(event.data));
      //       this.router.navigateByUrl('/anre/furnizor-fui');
      //       break;
      //     }
      //     case 'suspend': {
      //       localStorage.setItem('supplier', JSON.stringify(event.data));
      //       localStorage.setItem('licence', JSON.stringify(event.data.gasLicence));
      //       this.router.navigateByUrl('/anre/licenta-furnizor');
      //       break;
      //     }
      //     case 'view': {
      //       localStorage.setItem('supplierId', event.data.id);
      //       this.router.navigateByUrl('/anre/furnizor-detalii');
      //       break;
      //     }
      case 'modifyIntegration': {
        event.data.integrated = !event.data.integrated;
        this.anreService.modifyOperatorIntegration(event.data).subscribe(() => this.ngOnInit());
        break;
      }
    }
  }

  eeOperatorsLoaded(value: OperatorList): void {
    this.eeOperators = value.operatorListItems
    this.totalResultsElectr = value.totalResults
    this.paginationElementsElectr = []
    for (let i = 0; i < value.totalResults / this.size; i++) {
      this.paginationElementsElectr[i] = { pageNumber: i, className: "page-item" }
    }
    this.paginationElementsElectr[this.pageElectr].className = "page-item active"
  }

  gnOperatorsLoaded(value: OperatorList): void {
    console.log(value);
    this.gnOperators = value.operatorListItems
    this.totalResultsGas = value.totalResults
    this.paginationElementsGas = []
    for (let i = 0; i < value.totalResults / this.size; i++) {
      this.paginationElementsGas[i] = { pageNumber: i, className: "page-item" }
    }
    this.paginationElementsGas[this.pageGas].className = "page-item active"
  }

  changePage(page: Pagination): void {
    if (this.tabset.activeId === 'energie-electrica') {
      this.pageElectr = page.pageNumber
      this.anreService.getAnreElectricOperators(this.nameFilterElectr, this.codeFilterElectr, this.pageElectr, this.size).subscribe(value => this.eeOperatorsLoaded(value));
    }
    else if (this.tabset.activeId === 'gaze-naturale') {
      this.pageGas = page.pageNumber
      this.anreService.getAnreGasOperators(this.nameFilterGas, this.codeFilterGas, this.pageGas, this.size).subscribe(value => this.gnOperatorsLoaded(value));
    }
  }

  previousPage(): void {
    if (this.tabset.activeId === 'energie-electrica' && this.pageElectr > 0) {
      this.pageElectr = --this.pageElectr
      this.anreService.getAnreElectricOperators(this.nameFilterElectr, this.codeFilterElectr, this.pageElectr, this.size).subscribe(value => this.eeOperatorsLoaded(value));
    }
    else if (this.tabset.activeId === 'gaze-naturale' && this.pageGas > 0) {
      this.pageGas = --this.pageGas
      this.anreService.getAnreGasOperators(this.nameFilterGas, this.codeFilterGas, this.pageGas, this.size).subscribe(value => this.gnOperatorsLoaded(value));
    }
  }

  nextPage(): void {
    if (this.tabset.activeId === 'energie-electrica' && this.pageElectr < this.totalResultsElectr / this.size - 1) {
      this.pageElectr = ++this.pageElectr
      this.anreService.getAnreElectricOperators(this.nameFilterElectr, this.codeFilterElectr, this.pageElectr, this.size).subscribe(value => this.eeOperatorsLoaded(value));
    }
    else if (this.tabset.activeId === 'gaze-naturale' && this.pageGas < this.totalResultsGas / this.size - 1) {
      this.pageGas = ++this.pageGas
      this.anreService.getAnreGasOperators(this.nameFilterGas, this.codeFilterGas, this.pageGas, this.size).subscribe(value => this.gnOperatorsLoaded(value));
    }
  }

  search(): void {
    console.log(this.tabset.activeId)
    if (this.tabset.activeId === 'energie-electrica')
      this.anreService.getAnreElectricOperators(this.nameFilterElectr, this.codeFilterElectr, this.pageElectr, this.size).subscribe(value => this.eeOperatorsLoaded(value));
    else if (this.tabset.activeId === 'gaze-naturale')
      this.anreService.getAnreGasOperators(this.nameFilterGas, this.codeFilterGas, this.pageGas, this.size).subscribe(value => this.gnOperatorsLoaded(value));
  }

}
